function readImportMetaMode() {
    try {
        return new Function('return import.meta.env && import.meta.env.MODE;')();
    } catch {
        return undefined;
    }
}

export function getAppMode() {
    const mode = readImportMetaMode();
    return String(mode || '').trim().toLowerCase();
}

export function isAppProductionMode() {
    const mode = getAppMode();
    return mode === 'prod' || mode === 'production';
}
